import { isHttpClientError } from "@/http";
import { storageBackendErrorText } from "./storageBackendText";

// 비동기 1회 로드 상태(공용). 목록, 상세, 리뷰가 같은 형태를 쓴다.
export type LoadState<T> =
  | { status: "idle" }
  | { status: "loading" }
  | { status: "success"; data: T }
  | { status: "error"; message: string };

// 알 수 없는 에러를 사용자 메시지로 바꾼다. HttpClientError 와 Error 는 message 를 쓴다.
// 그 외에는 기본 문구를 반환한다.
export function resolveLoadErrorMessage(error: unknown): string {
  const storageBackendText = storageBackendErrorText(error);
  if (storageBackendText !== null) {
    return storageBackendText;
  }
  if (isHttpClientError(error)) {
    if (error.code === "extra_file.annotation_protected")
      return "Annotation이 관리하는 경로는 수정할 수 없습니다. 새 번들은 Dataset 상세 → Annotation → 파일에서 가져오기를 이용해 주세요.";
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "요청을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.";
}
